export const projectsData = [
  {
    id: 1,
    title: "UniGlobe Edu",
    description: "An Educational consultancy site\n",
    img: require("./../../assets/UniGlobeEdu.png"),
    client_code: "",
    live_site: "https://www.uniglobeedu.com/",
    tech1: "React",
    tech2: "NodeJs",
    tech3: "Express",
  },
  {
    id: 2,
    title: "Medicare",
    description: "A healthcare related site\n",
    img: require("./../../assets/medicare1.png"),
    client_code:
      "https://github.com/SakibSaizeed/healthcare-related-website-SakibSaizeed",

    live_site: "https://medicaredhaka.netlify.app/",
    tech1: "React",
    tech2: "NodeJs",
    tech3: "Firebase Auth",
  },
  {
    id: 3,
    title: "Travellers",
    description: "A tourism related Booking website\n Fullstack",
    img: require("./../../assets/travellers.png"),
    client_code: "https://github.com/SakibSaizeed/travellers-client",
    backend_code: "",
    live_site: "https://lively-travellers.netlify.app/",
    tech1: "React",
    tech2: "NodeJs",
    tech3: "Express",
  },
  {
    id: 4,
    title: "CarShop",
    description: "A simple web layout using  with Html5,JS and CSS3",
    img: require("./../../assets/carshop.png"),
    client_code: "https://github.com/SakibSaizeed/",
    backend_code: "",
    live_site: "https://saizeedcarshop.netlify.app/",
    tech1: "HTML5",
    tech2: "ES6",
    tech3: "CSS3",
  },
  {
    id: 5,
    title: "Responsive Football",
    description: "A simple sports website landing page",
    img: require("./../../assets/football.png"),
    client_code: "https://github.com/SakibSaizeed/responsive-football",
    backend_code: "",
    live_site: "https://sakibsaizeed.github.io/responsive-football/",
    tech1: "HTML5",
    tech2: "CSS3",
    tech3: "JS",
  },
  {
    id: 6,
    title: "E-Shop",
    description: "E-Commerce web landing page",
    img: require("./../../assets/eshop.png"),
    client_code: "https://github.com/SakibSaizeed/",
    backend_code: "",
    live_site: "https://sakibsaizeedeshop.netlify.app/",
    tech1: "HTML5",
    tech2: "CSS3",
    tech3: "JS",
  },
  {
    id: 7,
    title: "Food Network",
    description: "A simple static  web page with HTML5,CSS3",
    img: require("./../../assets/foodnet.png"),
    client_code: "https://github.com/SakibSaizeed/food-network",
    backend_code: "",
    live_site: "https://sakibsaizeed.github.io/food-network/",
    tech1: "HTML5",
    tech2: "CSS3",
  },
  {
    id: 8,
    title: "Money Maker",
    description: "A simple online calculator ",
    img: require("./../../assets/Moneymaker.png"),
    client_code: "https://github.com/SakibSaizeed/money-maker-DOM",
    backend_code: "",
    live_site: "https://cheery-cocada-35fa24.netlify.app/",
    tech1: "Vanilla JS",
    tech2: "JS DOM",
    tech3: "CSS3",
  },
  {
    id: 9,
    title: "Know The flag",
    description: "A simple web app using  api with JS DOM and Events",
    img: require("./../../assets/Project Country Flag.png"),
    client_code: "https://github.com/SakibSaizeed/Know_the_nation",
    backend_code: "",
    live_site: "https://knowtheflag.netlify.app/",
    tech1: "Javascript",
    tech2: "API",
    tech3: "CSS3",
  },
];
